<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     width="16px" height="16px" viewBox="0 0 12.7 12" xml:space="preserve">
    <polyline points="0,10.8 4.3,8 8.5,9.7 12.7,6.4 12.7,2.6 8.5,7.5 4.3,5 0,6.1 0,10.8"/>
    <polyline points="-0.2,4.3 4.2,2.6 8.1,4.3 13.1,1.1"/>
</svg>
